var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.691 35.691"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 102"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 194",
    d: "M35.6 30.583a1.394 1.394 0 00-2.73.568 1.457 1.457 0 01-.3 1.221 1.416 1.416 0 01-1.115.53H4.231a1.417 1.417 0 01-1.115-.53 1.457 1.457 0 01-.3-1.221 15.4 15.4 0 0114.656-12.2q.184.007.37.007t.371-.007A15.337 15.337 0 0130.6 25.762a1.394 1.394 0 102.316-1.553 18.135 18.135 0 00-9.4-7.139 9.481 9.481 0 10-11.348 0A18.134 18.134 0 00.091 30.583a4.236 4.236 0 004.14 5.108h27.23a4.236 4.236 0 004.14-5.108zM11.154 9.481a6.692 6.692 0 117.031 6.684h-.676a6.7 6.7 0 01-6.355-6.684z",
    fill: "currentColor"
  }))));
}

export default SvgUserinline;